import { api } from './client';
import { endpoints } from './endpoints';

/** Student-facing applications. The company pipeline lives in company.api.js. */
export function listApplications(params) {
  return api.getPaginated(endpoints.applications.root, { params });
}

/** How many of the student's applications sit at each status, for the tabs. */
export function getApplicationCounts() {
  return api.get(`${endpoints.applications.root}/counts`);
}

export function getApplication(id) {
  return api.get(endpoints.applications.byId(id));
}

export function apply(input) {
  return api.post(endpoints.applications.root, input);
}

/**
 * Change the CV, cover letter or answers on an application already sent.
 *
 * The window is the server's to enforce; `can_edit` on the application says
 * whether it is worth offering, and a refusal comes back as a 409.
 */
export function updateApplication(id, input) {
  return api.patch(endpoints.applications.byId(id), input);
}

export function withdrawApplication(id, reason) {
  return api.post(endpoints.applications.withdraw(id), { reason });
}
